<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
              <!-- 左侧竖向步骤条 -->
              <div style="width: 220px; min-width: 240px; margin-right: 24px;">
                <el-steps direction="vertical" :active="activeValue" class="custom-steps-vertical">
                  <el-step v-for="(itemf, index) of activeList"
                          :key="index" :title="itemf.processNodeName" :description="itemf.approvalTime"></el-step>
                </el-steps>
              </div>
              <!-- 右侧内容 -->
              <div style="flex: 1; overflow-x: auto;">
                <Boyo-Formtwo :formInfo="formInfo2"
                        :refObj.sync="formInfo2.ref"
                        :listTypeInfo='listTypeInfo'
                        @handlePictureCardPreview="handlePictureCardPreview">
                </Boyo-Formtwo>
                <el-table :data="tableData"
                        max-height="430"
                        border
                        show-summary
                        :summary-method="getSummaries"
                        style="width: 100%;margin-top:12px;margin-bottom:12px"
                        :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                        :cell-style="{padding:'2px'}">
                <el-table-column fixed="left"
                    type="index"
                    width="50">
                  </el-table-column>
                <el-table-column prop="billDate" align="center" width="100px"
                                label="日期">
                </el-table-column>
                <el-table-column prop="factoryAreaName"
                                align="center"
                                label="所属单位" width='130px'>
                </el-table-column>
                <el-table-column prop="freightType"
                                align="center"
                                label="类型" width='110px'>
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.freightType" :disabled="true">
                      <el-option v-for="item in listTypeInfo.freightType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="carrierName"
                                align="center"
                                label="收款单位" width='120px'>
                </el-table-column>
                <el-table-column prop="shipNo"
                                align="center"
                                label="船号" width="90px">
                </el-table-column>
                <el-table-column prop="containerNo"
                                align="center"
                                label="柜号" width="90px">
                </el-table-column>
                <el-table-column prop="settleQuantity"
                                align="center"
                                label="数量" width="90px">
                </el-table-column>
                <el-table-column prop="settleTaxRate"
                                align="center"
                                label="税率%" width='70px'>
                </el-table-column>
                <el-table-column prop="settleExctTaxPrice"
                                align="center"
                                label="不含税单价" width="70px">
                </el-table-column>
                <el-table-column prop="settlePrice"
                                align="center"
                                label="含税单价" width="70px">
                </el-table-column>
                <el-table-column prop="settleExctTaxAmount"
                                align="center"
                                :label="'不含税金额/'+amountUnit" width="105px">
                </el-table-column>
                <el-table-column prop="settleAmount"
                                align="center"
                                :label="'含税金额/'+amountUnit" width="105px">
                </el-table-column>
                <el-table-column prop="wastageQuantity"
                                align="center"
                                label="损耗量" width="90px">
                </el-table-column>
                <el-table-column prop="wastagePrice"
                                align="center"
                                label="损耗单价" width="90px">
                </el-table-column>
                <el-table-column prop="wastageAmount"
                                align="center"
                                :label="'损耗金额/'+amountUnit" width="105px">
                </el-table-column>
                <el-table-column prop="actualAmount"
                                align="center"
                                :label="'实付金额/'+amountUnit" width="105px">
                </el-table-column>
              </el-table>
                <!-- 审核表单 -->
                <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
                   <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                  <Boyo-Formtwo :formInfo="formInfoAuditData"
                             :refObj.sync="formInfoAuditData.ref"
                             :listTypeInfo="listTypeInfo">
                  </Boyo-Formtwo>
                </div>
              </div>
            </div>
        </Boyo-Dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="pingImgUrl+dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" class="imgDialog">
            <img width="100%" :src="dialogImageUrl2" alt="">
        </el-dialog>
    </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'FreightSettlementDialog',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm,BoyoFormtwo
  },
  props: {},
  data () {
    return {
      activeValue:null,
      activeList:[],
      dataId:'',
      search: {},
      tableData:[],
      detailDate:{},
      billId:'',
      add2:0,
      dialogVisible:false,
      dialogImageUrl:'',
      dialogImageUrl2: '',
      dialogVisible2: false,
      pingImgUrl: config.pingImgUrl,
      amountUnit:localStorage.amountUnit,
      auditParm:{},
      createdBy: null, // 保存传入的制单人
      createdTime: null, // 保存传入的制单时间
      showAuditDataFields: false, // 是否显示审核表单
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '运费结算单'
        ],
        showPhraseManager: false,
        newPhrase: '',
      formInfoAuditData: {
        ref: null,
        labelWidth: '100px',
        data: {
          id:'',
          factoryAreaId:'',
          factoryAreaCode:'',
          factoryAreaName:'',
          processId:'',
          remark:'',
          status:'',
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
        ],
        rules: {
          status:[{ required: true, trigger: 'change',message: '请选择' }]
        }
      },
      // 下拉框相关信息
      listTypeInfo: {
        freightType: [{ value: 0, label: '车运费(直采、长协)' }, { value: 1, label: '船运费(移库)' }, { value: 2, label: '车船运(场地到码头)' }, { value: 3, label: '车船运(码头到本部)' }, { value: 4, label: '车运费(移库)' }, { value: 5, label: '船运费(直采、长协)' }, { value: 6, label: '装卸费' }, { value: 7, label: '保险费' }, { value: 8, label: '杂费' }],
        purMode :[],
        submitStatus:[{ label: '否', value: 0 },{ label: '是', value: 1 }],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
        processId:[],
      },
      formInfo2: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          id: null,
          settleNo: '',
          settleDate: '',
          carrierName: '',
        },
        list: [
          {type: "text",label: "结算编号：",value: "settleNo", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "收款单位：",value: "carrierName", style: 'width:95%', className: 'form_item_two',disabled:true},
        ],
        rules: {}
      },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '运费结算单对应数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false ,show:false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
    }
  },
  created () {
  },
  mounted () {
    // this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,enumCategoryCode:'PurMode'}).then(res => {
    //     if(res.code == 0) {
    //         let list1 = res.data.list
    //         for( let i in list1 ) {
    //             this.listTypeInfo.purMode.push({value: Number(list1[i].enumName), label: list1[i].enumValue})
    //         }
    //     }
    // })
  },
  methods: {
     // 小计计算方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        }
        
        // 初始化空值
        sums[index] = '';
        
        // 需要计算小计的列
        const calcColumns = [
          'settleQuantity',
          'settleExctTaxAmount',
          'settleAmount',
          'wastageQuantity',
          'wastageAmount',
          'actualAmount'
        ];
        
        if (calcColumns.includes(column.property)) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            
            // 格式化金额显示
            if (sums[index] !== '') {
              sums[index] = this.formatAmount(Number(sums[index].toFixed(2)));
            }
          }
        }
      });
      
      return sums;
    },
    dialogShow(data, val, parm, id, maker, makerTime){
        this.billId = data
        this.dataId = id
        // 保存传入的制单人和时间
        this.createdBy = maker
        this.createdTime = makerTime
        if(parm && parm.id){
          this.auditParm = parm
          this.dialogInfoData.btList[0].show = true
          this.showAuditDataFields = true
          // 初始化审核表单数据
          this.$nextTick(() => {
            for (const key in this.formInfoAuditData.data) {
              this.formInfoAuditData.data[key] = ''
            }
            // 查找并设置流程名称
            const loadProcessEnum = () => {
              return new Promise((resolve) => {
                if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                  resolve();
                } else {
                  this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                    if(res.code == 0) {
                      let list1 = res.data.list
                      for(let i in list1) {
                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                      }
                      resolve();
                    } else {
                      this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                      resolve();
                    }
                  }).catch(() => {
                    resolve();
                  });
                }
              });
            };
            // 加载流程枚举后再设置流程名称
            loadProcessEnum().then(() => {
              let processFound = false;
              for (let inde of this.listTypeInfo.processId) {
                if (parm.processId == inde.enumValue) {
                  this.formInfoAuditData.data.processId = inde.value
                  processFound = true;
                  break;
                }
              }
              // 如果没找到匹配的流程，记录日志并设置一个默认值
              if (!processFound) {
                console.warn('未找到匹配的流程ID:', parm.processId, '可用的流程枚举:', this.listTypeInfo.processId);
                // 直接使用processId作为备选
                this.formInfoAuditData.data.processId = parm.processId;
              }
              this.formInfoAuditData.data.status = 1
            });
          })
        }else{
          this.dialogInfoData.btList[0].show = false
          this.showAuditDataFields = false
        }
        this.getInfo(val)
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 搜索事件
    getInfo (val) {
      this.$api.system.getActProcessEntryPage({idProcessInstance:this.dataId,pageNum:1,pageSize:999}).then(res => {
          if (res.code == 0) {
              this.activeList = []
              this.activeValue = 0
              for (let i in res.data.list) {
                  if(res.data.list[i].status && i < res.data.list.length){
                      this.activeValue = Number(Number(i) + 1)
                  }
                  this.activeList.push({processNodeName:(res.data.list[i].processNodeName?res.data.list[i].processNodeName:'流程节点名称暂无') + (res.data.list[i].status?'(审核完成)':'(未完成)'),approvalTime:res.data.list[i].status?(res.data.list[i].actualApprover + ' ' + res.data.list[i].approvalTime):(res.data.list[i].approver?('审批人：' + res.data.list[i].approver):('审批角色：' + res.data.list[i].roleName))})
              }
               // 始终在最前面插入"制单人"节点
              // 优先使用传入的制单人和时间，如果没有则尝试使用val中的数据
              let maker = this.createdBy || (val && val.createBy ? val.createBy : '暂无');
              let makerTime = this.createdTime || (val && val.createTime ? val.createTime : '');
              let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
              this.activeList.unshift({ processNodeName: '制单人', approvalTime });
              this.activeValue = (this.activeValue || 0) + 1;
          }else{
              this.$message({ message: res.msg, type: "error" });
          }
      })
      this.$api.OrderPurchase.getPurFreightSettleList({settleNo:this.billId,pageNum:1,pageSize:0}).then(
        res => {
          if (res.code == 0) {
            if(res.data.list.length > 0){
                this.detailDate = res.data.list[0]
                for (let key in this.formInfo2.data) {
                  this.formInfo2.data[key] = ''
                }
                this.detailDate.accessDate = this.detailDate.accessDate?this.detailDate.accessDate.substring(0,10):''
                for (let key in this.detailDate) {
                  if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                  }
                }
                this.$api.OrderPurchase.getPurFreightPage({settleNo:this.billId,pageNum:1,pageSize:999}).then(res => {
                  if (res.code == 0) {
                    this.tableData = res.data.list
                  }else{
                    this.$message({ message: res.msg, type: "error" });
                  }
                })
                if(!val){
                  this.dialogInfoData.visible = true
                }
            } else {
                this.$message({ message: '对应数据查找为空', type: 'warning' })
            }
          }else{
            this.$message({ message: res.msg, type: "error" });
          }
        },
        err => {
          console.log(err)
          this.content.loading = false
        }
      )
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              this.formInfoAuditData.ref.validate(valid => {
                if (valid) {
                  let parma = {
                    id: this.auditParm.id,
                    processId: this.formInfoAuditData.data.processId,
                    status: this.formInfoAuditData.data.status,
                    remark: this.formInfoAuditData.data.remark
                  }
                  dialogInfoData.btList[0].loading = true
                  this.$api.system.approval(parma).then(res => {
                    dialogInfoData.btList[0].loading = false
                    if (res.code === 0) {
                      this.$message({ message: res.msg, type: 'success' })
                      dialogInfoData.visible = false
                      this.showAuditDataFields = false
                      this.$emit('refreshInfo') // 审核成功后通知父组件刷新
                    } else {
                      this.$message({ message: res.msg, type: 'error' })
                    }
                  }).catch(() => {
                    dialogInfoData.btList[0].loading = false
                  })
                }
              })
              break
            case 'close':
                dialogInfoData.visible = false
                this.showAuditDataFields = false
                this.$emit('refreshInfo') // 关闭弹窗时通知父组件刷新
                break
        }
    },
    // 表单内部事件
    formClick (event) {
      switch (event) {
      }
    },
    previewAvatar(file) { // 查看文件
      window.open(config.pingImgUrl + file.url)
    },
    handlePictureCardPreview (url, value) {
      if(url){
        this.dialogVisible2 = true
        this.dialogImageUrl2 = url
      }
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>
<style lang="stylus" scoped>
.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/FreightSettlementDialog.vue